import React, { ComponentProps, useState } from "react";
import { Image } from "react-bootstrap";

import "./GemBalance.scss";
import Gem from "../../Gem/Gem";
import GemInfoModal from "../modals/GemInfoModal/GemInfoModal";
import ImageHourglass from "../../../images/hourglass.svg";
import GhostButton from "../GhostButton/GhostButton";
import GemExpiringModal from "../modals/GemExpiringModal/GemExpiringModal";
import { TimeUnit, getTimeDifferenceToNow } from "../../../utils/helpers";

interface GemBalanceProps extends ComponentProps<"button"> {
  balance?: number;
  expirationDate?: string;
}

const THRESHOLD_TO_SHOW_EXPIRATION_LABEL = 5;

function GemBalance({
  balance,
  expirationDate,
  ...restProps
}: GemBalanceProps) {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showExpiringModal, setShowExpiringModal] = useState(false);

  const balanceText = balance === undefined ? "--" : balance.toString();
  const expirationInfo = getTimeDifferenceToNow(expirationDate);
  const expirationText = expirationInfo
    ? `${expirationInfo.difference} ${expirationInfo.unit}${
        expirationInfo.difference === 1 ? "" : "s"
      }`
    : "";
  const canShowExpirationLabel =
    expirationInfo &&
    ((expirationInfo.unit === TimeUnit.DAY &&
      expirationInfo.difference > 0 &&
      expirationInfo.difference <= THRESHOLD_TO_SHOW_EXPIRATION_LABEL) ||
      (expirationInfo.unit !== TimeUnit.DAY && expirationInfo.difference > 0));

  return (
    <div className="gem-balance-container">
      <button
        className="gem-balance"
        onClick={() => setShowInfoModal(true)}
        {...restProps}
      >
        <Gem width="20px" height="20px" />
        <span>{balanceText}</span>
      </button>
      {canShowExpirationLabel && (
        <GhostButton
          className="time-left"
          style={{ right: -16, top: -10 }}
          aria-label="view gem expiration info"
          onClick={() => setShowExpiringModal(true)}
        >
          <Image
            src={ImageHourglass}
            alt="hourglass"
            width={7}
            height={12}
            className="hourglass"
          />{" "}
          <span>{expirationText}</span>
        </GhostButton>
      )}
      <GemInfoModal
        balance={balanceText}
        show={showInfoModal}
        onHide={() => setShowInfoModal(false)}
      />
      <GemExpiringModal
        show={showExpiringModal}
        onHide={() => setShowExpiringModal(false)}
        daysToExpire={expirationText}
      />
    </div>
  );
}

export default GemBalance;
